import { get } from 'lodash';
import { addYears } from 'date-fns';
import { clientCookies } from 'utils/cookies';

export const SET_MOBILE_APP_BANNER_CLOSED = 'SET_MOBILE_APP_BANNER_CLOSED';

export function setBannerClosed() {
  return {
    type: SET_MOBILE_APP_BANNER_CLOSED,
  };
}

export function closeBanner() {
  return (dispatch, getState) => {
    const nextYear = addYears(Date.now(), 1);

    const placedOrdersCount = get(getState(), 'user.shoppingDetails.placedOrdersCount');
    // Setting cookie is required by webshop backend to determine if banner should be
    // visible during next page refresh.
    // @see: com.oc*.webshop.appbanner.orders.MobileAppBannerOrdersService.java file
    if (typeof placedOrdersCount !== 'undefined') {
      clientCookies.set('MAB_LSPOC', placedOrdersCount, {
        expires: nextYear,
        path: '/',
        httpOnly: false,
        secure: true,
      });
    }
    dispatch(setBannerClosed());
  };
}
